import React from 'react';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  YAxis
} from 'recharts';

export interface SparklinePoint {
  date: string;
  count: number;
}

const Sparkline: React.FC<{
  data: SparklinePoint[];
  stroke?: string;
}> = ({ data, stroke = '#6366f1' }) => {
  if (!data || data.length === 0) return null;

  return (
    <div style={{ width: '100%', height: 48 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <YAxis hide domain={['auto', 'auto']} />
          <Line type="monotone" dataKey="count" stroke={stroke} strokeWidth={2} dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Sparkline;






























